import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class ExternalDashboardsSettingsService {
  constructor(private http: HttpClient) {}

  public fetchExternalDashboardsSettings(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_EXTERNAL_DASHBOARDS`
    return this.http.get(url, {})
  }

  public updateExternalDashboardsSettings(payload: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_EXTERNAL_DASHBOARDS`
    return this.http.put(url, payload)
  }
}
